import React, { useEffect, useState } from 'react';
import { Table } from 'antd';
import { configManager } from 'react-structure-admin';
import Pagination from 'components/Pagination';

const ListTable = (props) => {
  const {
    dataSource,
    loading,
    pagination,
    children,
    initEditing,
    rowSelection,
    className,
    handleTableChange,
    columns,
    components,
    moveRow,
    onDoubleClick,
    disableDoubleClick,
    disablePagination,
    removeRecord,
    showHeader,
    expandable
  } = props;

  const [currentPage, setCurrentPage] = useState(pagination?.current ?? 1);

  useEffect(() => {
    setCurrentPage(pagination?.current ?? 1);
  }, [pagination?.current]);

  const handleDoubleClick = (record) => {
    if (disableDoubleClick) {
      return;
    }

    if (onDoubleClick) {
      onDoubleClick(record, initEditing);
      return;
    }

    if (initEditing) {
      initEditing(record);
    }
  };

  const handlePageChange = (isNext = false) => {
    let newPage = currentPage ?? 1;

    if (isNext) newPage++;
    else newPage = Math.max(1, newPage - 1);

    setCurrentPage(newPage);

    pagination.current = newPage;
    handleTableChange({ current: newPage });
  };

  return (
    <div className={className}>
      <Table
        scroll={{ x: 400 }}
        size={configManager.getConfig().layout.list.table.size}
        loading={loading}
        rowKey={(record) => record.id ?? record.uuid}
        rowSelection={rowSelection}
        pagination={pagination?.total == null ? false : pagination}
        onChange={handleTableChange}
        dataSource={dataSource}
        showHeader={showHeader}
        columns={columns}
        expandable={expandable}
        components={components}
        onRow={(record, index) => {
          const rowProps = {
            onDoubleClick: () => handleDoubleClick(record)
          };

          // index/moveRow só servem à row customizada de drag-and-drop (react-dnd), que os consome.
          // Sem reordenação (moveRow ausente) eles vazariam para o <tr> do DOM e o React avisa
          // "does not recognize the moveRow prop on a DOM element".
          if (moveRow) {
            rowProps.index = index;
            rowProps.moveRow = moveRow;
          }

          return rowProps;
        }}
      >
        {typeof children === 'function'
          ? children({ initEditing, removeRecord })
          : children}
      </Table>

      {pagination.total == null && (
        <Pagination
          loaded={!props.loading}
          onClickNext={() => handlePageChange(true)}
          onClickPrev={() => handlePageChange()}
          pagination={pagination}
        />
      )}
    </div>
  );
};

export default ListTable;
